<div class="devstroupe-drawer-content">
    <ng-content></ng-content>
</div>
